import {
  GET_ALL_SETTINGS,
  GET_ALL_SETTINGS_SUCCESS,
  GET_ALL_SETTINGS_FAILURE,
  EDIT_SETTINGS,
  EDIT_SETTINGS_SUCCESS,
  EDIT_SETTINGS_FAILURE,
  EDIT_TAXNUMBER,
  EDIT_TAXNUMBER_SUCCESS,
  EDIT_TAXNUMBER_FAILURE,
  SUBMIT_IDENTITY,
  SUBMIT_IDENTITY_SUCCESS,
  SUBMIT_IDENTITY_FAILURE,
  GET_IDENTITY,
  GET_IDENTITY_SUCCESS,
  GET_IDENTITY_FAILURE,
  GET_TAXNUMBER,
  GET_TAXNUMBER_SUCCESS,
  GET_TAXNUMBER_FAILURE,
} from "./actionTypes";

export const getAllSettings = () => {
  return {
    type: GET_ALL_SETTINGS,
  };
};
export const getAllSettingsSuccess = (payload) => {
  return {
    type: GET_ALL_SETTINGS_SUCCESS,
    payload: payload,
  };
};

export const getAllSettingsFailure = (error) => {
  return {
    type: GET_ALL_SETTINGS_FAILURE,
    payload: error,
  };
};

export const editSettings = (payload) => {
  return {
    type: EDIT_SETTINGS,
    payload: payload,
  };
};
export const editSettingsSuccess = (payload) => {
  return {
    type: EDIT_SETTINGS_SUCCESS,
    payload: payload,
  };
};

export const editSettingsFailure = (error) => {
  return {
    type: EDIT_SETTINGS_FAILURE,
    payload: error,
  };
};

export const getTaxNumber = (payload) => {
  return {
    type: GET_TAXNUMBER,
    payload,
  };
};

export const getTaxNumberSuccess = (payload) => {
  return {
    type: GET_TAXNUMBER_SUCCESS,
    payload,
  };
};

export const getTaxNumberFailure = (payload) => {
  return {
    type: GET_TAXNUMBER_FAILURE,
    payload,
  };
};

export const editTaxNumber = (payload) => {
  return {
    type: EDIT_TAXNUMBER,
    payload,
  };
};

export const editTaxNumberSuccess = (payload) => {
  return {
    type: EDIT_TAXNUMBER_SUCCESS,
    payload,
  };
};

export const editTaxNumberFailure = (payload) => {
  return {
    type: EDIT_TAXNUMBER_FAILURE,
    payload,
  };
};

export const getIdentityVerification = (payload) => {
  return {
    type: GET_IDENTITY,
    payload,
  };
};

export const getIdentityVerificationSuccess = (payload) => {
  return {
    type: GET_IDENTITY_SUCCESS,
    payload,
  };
};

export const getIdentityVerificationFailure = (payload) => {
  return {
    type: GET_IDENTITY_FAILURE,
    payload,
  };
};
export const submitIdentityVerification = (payload) => {
  return {
    type: SUBMIT_IDENTITY,
    payload,
  };
};

export const submitIdentityVerificationSuccess = (payload) => {
  return {
    type: SUBMIT_IDENTITY_SUCCESS,
    payload,
  };
};

export const submitIdentityVerificationFailure = (payload) => {
  return {
    type: SUBMIT_IDENTITY_FAILURE,
    payload,
  };
};
